// extracted by mini-css-extract-plugin
module.exports = {"button":"_38tWERZFaKuVTPx5US3BNv","icon":"_3FUTl8ZRGv4FcTQj74D99V"};